// extracted by mini-css-extract-plugin
export default {"buttonPosition":"styles_buttonPosition__eI2yh"};